<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container">

        <div class="row">

          <div id="categories-list" class="col-md-3">
            <h4>Categorias</h4>
            <ul>
              <li :class="{active: !category && !selectedFeat && !selectedFav}"><a href="" @click.stop.prevent="selectCategory(null)">Todos os Projetos</a></li>
              <li v-if="isAuth && showFavorites" :class="{active: selectedFav}"><a href="" @click.stop.prevent="selectFavoritedProjects()">Meus Favoritos</a></li>
              <li v-if="isAuth" :class="{active: selectedFeat}"><a href="" @click.stop.prevent="selectFavoritedCategories()">Destaques</a></li>
              <li :class="{active: category && category.CategoryId === c.CategoryId}" v-for="c in categoriesList" :key="c.CategoryId" @click.stop.prevent="selectCategory(c.CategoryId)">
                <a href="">{{c.name}}</a>
              </li>
            </ul>

            <h4 class="location-title">Localização</h4>
            <form class="location-form">
              <div class="form-group">
                <label for="inputEmail4">Cidade</label>
                <input type="text" class="form-control" id="inputCity" placeholder="Busque por uma cidade" v-model="searchCity" @keyup="searchProjectByCity()">
              </div>
            </form>

            <h4 class="onu-title">Objetivos da ONU</h4>
            <form class="onu-form">
              <b-form-checkbox-group id="checkboxes2" name="flavour2" v-model="ods" @change="filterByODS">
                <b-form-checkbox v-for="o in odsList" :key="o.number" class="mb-2" :value="o.slug">{{o.title}}</b-form-checkbox>
              </b-form-checkbox-group>
            </form>
          </div>

          <div id="projects-list" class="col-md-9">
            <div class="breadcrumb-list">
              <ul>
                <li>CONHECER</li>
                <li class="active" v-if="!category && !selectedFav && !selectedFeat">TODOS OS PROJETOS</li>
                <li class="active" v-if="!category && !selectedFav && selectedFeat">PROJETOS DESTAQUES</li>
                <li class="active" v-if="!category && selectedFav && !selectedFeat">PROJETOS FAVORITADOS</li>
                <li class="active" v-if="category">{{category.name.toUpperCase()}}</li>
              </ul>
            </div>
            <div class="category-cover">
              <v-lazy-image v-if="categoryImage" :src="categoryImage" src-placeholder=""/>
              <div v-if="!category && !selectedFeat && !selectedFav" class="content">
                <h2>Todas Organizações Sociais</h2>
                <p>Emocione-se com a diversidade de boas ações esperando por você.</p>
              </div>
              <div v-if="!category && !selectedFav && selectedFeat" class="content">
                <h2>Projetos Destaque</h2>
                <p>Selecionamos alguns projetos baseados em suas preferências.</p>
              </div>
              <div v-if="!category && selectedFav && !selectedFeat" class="content">
                <h2>Projetos Favoritados</h2>
                <p>Aqui você encontrará a lista de todos os projetos que favoritou.</p>
              </div>
              <div v-if="category" class="content">
                <h2>{{category.name}}</h2>
                <p>{{category.description}}</p>
              </div>
            </div>

            <div class="tabs d-none">
              <ul class="filter">
                <li class="active"><a href="">Populares</a></li>
                <li><a href="">Novos</a></li>
                <li><a href="">Maior arrecadação</a></li>
              </ul>
            </div>

            <div id="listProjects" class="projects row" v-if="projectsList && projectsList.length > 0">

              <div class="col-md-6 col-sm-6 col-lg-4" v-for="p in projectsList" :key="p.ProjectId">
                <div class="item" @click="openProject(p.slug)" @contextmenu.prevent="openProjectInNewTab(p.slug)">
                  <div class="image">
                    <img v-if="p.Info.image && p.Info.image.length > 0 && p.Info.image.search('via.placeholder.com') == -1" :src="p.Info.image" />
                    <img v-else src="https://via.placeholder.com/500x500&text=Sem+Foto" />
                    <!-- <button v-if="isAuth" @click.stop.prevent="donate(p)" class="btn btn-success one-click">Doe com um clique!</button> -->
                  </div>
                  <div class="content">
                    <h5>{{p.Info.title}}</h5>
                    <div class="donations">
                      <span v-if="p.Donations"><b>{{getDonationsValue(p)}}</b> de {{p.Donations.length}} doador(es)</span>
                      <span v-else>Valores indisponíveis</span>
                    </div>
                    <!-- <div v-if="p.ODS" class="row">
                      <div class="col-md-12">
                        <a v-for="(slug, i) in p.ODS" :key="i" target="_blank" :href="getODS(slug).url" class="project-ods">
                          <img :src="getODS(slug).image"/>
                        </a>
                      </div>
                    </div> -->
                    <p class="description">
                      {{(p.Info.shortDescription && p.Info.shortDescription.length > 0) ? p.Info.shortDescription : null}}
                    </p>
                    <div class="tags">
                      <a v-for="cat in p.Categories" href="" v-if="cat.name" :key="cat.CategoryId">{{cat.name}}</a>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="projects row not-found" v-if="projectsList && projectsList.length == 0 && (!searchCity || (searchCity && searchCity.length == 0))">
              <h4>Nenhum projeto encontrado.</h4>
            </div>
            <div class="projects row not-found" v-if="projectsList && projectsList.length == 0 && searchCity && searchCity.length > 0">
              <h4>Não há projetos sociais disponíveis nesta cidade no momento.</h4>
            </div>
          </div>

        </div>

      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading" :message="loadingMessage"></Loading>

    <b-modal :ok-only="true" size="md" ok-title="Processar Doação" id="userDataModal" ref="userDataModal" title="Informe um valor a ser doado" @ok="submitFormDonation">
      <form method="post" class="donationForm" ref="formPayment">


        <div class="row">

          <div class="col-md-12">
            <div class="form-group">
              <label>Valor de Doação</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">R$</span>
                </div>
                <input required type="text" v-money="money" name="value" placeholder="Informe o valor que deseja doar para o projeto" v-model="donationValue" class="form-control input-value"/>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Mensagem</label>
              <input type="text" name="message" placeholder="Escreva uma mensagem para a equipe do projeto" v-model="donationMessage" class="form-control"/>
            </div>
          </div>

        </div>
        <div v-if="donationModalMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
          {{donationModalMsg}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

      </form>
    </b-modal>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import Loading from './includes/Loading'
import Functions from '../utils/functions'
import cover from '../assets/images/category_todos.jpg';
import coverFeatured from '../assets/images/featured.jpg';
import { API } from '../services/api'
import VLazyImage from "v-lazy-image";
import categoryLoading from '../assets/images/categoryLoading.png';
import {VMoney} from 'v-money';
import ods1 from '../assets/images/onu/1.png'
import ods2 from '../assets/images/onu/2.png'
import ods3 from '../assets/images/onu/3.png'
import ods4 from '../assets/images/onu/4.png'
import ods5 from '../assets/images/onu/5.png'
import ods6 from '../assets/images/onu/6.png'
import ods7 from '../assets/images/onu/7.png'
import ods8 from '../assets/images/onu/8.png'
import ods9 from '../assets/images/onu/9.png'
import ods10 from '../assets/images/onu/10.png'
import ods11 from '../assets/images/onu/11.png'
import ods12 from '../assets/images/onu/12.png'
import ods13 from '../assets/images/onu/13.png'
import ods14 from '../assets/images/onu/14.png'
import ods15 from '../assets/images/onu/15.png'
import ods16 from '../assets/images/onu/16.png'
import ods17 from '../assets/images/onu/17.png'
import auth from '../services/auth';

export default {
  name: 'Projects',
  directives: {money: VMoney},
  components: {
    Header,
    Footer,
    Loading,
    VLazyImage
  },
  data () {
    return {
      loading: true,
      loadingMessage: "Aguarde, carregando lista de projetos...",
      projects: null,
      projectsList: null,
      projectsListBackup: null,
      showFavorites: false,
      favoritedProjects: null,
      category: null,
      categoriesList: null,
      searchCity: null,
      categoryImage: categoryLoading,
      selectedFeat: false,
      selectedFav: false,
      donationModalMsg: '',
      donationValue: 0,
      integralDonationValue: 0,
      ods: null,
      odsList: Functions.getOdsList(),
      arrODSImages: [ods1, ods2, ods3, ods4, ods5, ods6, ods7, ods8, ods9, ods10, ods11, ods12, ods13, ods14, ods15, ods16, ods17],
      msg: '',
      msgShow: false,
      donationMessage: '',
      donationModalMsgShow: false,
      selectedProject: null,
      ProjectId: null,
      DonationId: null,
      isAuth: auth.isAuth(),
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  created(){
    this.loadProjects()
    this.loadProfile();
  },
  mounted (){

  },
  methods: {
    loadProfile(){
      if(this.isAuth){
        this.showFavorites = true;
        this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
          this.user = response.body.user;
        });
      }
    },
    loadProjects(){
      this.$http.get(API.Projects.projects).then((result) => {
        this.projects = result.body;
        this.projectsList = this.projects
        this.projectsListBackup = this.projectsList
        this.loadCategories();
      });
    },
    loadCategories(){
      this.$http.get(API.Projects.categories).then((result) => {
        this.loading = false
        this.categoriesList = result.body;
        if(this.$route.params.slug){
          var cat = this.categoriesList.filter((c) => {
            return c.url === this.$route.params.slug;
          })
          if(cat[0]){
            this.selectCategory(cat[0].CategoryId);
          }else if(this.$route.params.slug == 'featured'){
            this.selectFavoritedCategories();
          }else if(this.$route.params.slug == 'favorites'){
            this.selectFavoritedProjects();
          }
        }else{
          this.categoryImage = cover;
        }
      });
    },
    selectCategory(CategoryId){
      this.loading = true;
      this.category = false;
      this.categoryImage = null;
      this.selectedFav = false;
      this.selectedFeat = false;
      this.ods = null;

      if(CategoryId){
        var category = this.categoriesList.filter((c) => {
          return c.CategoryId === CategoryId;
        });
        this.category = category[0]
        setTimeout(() => {
          this.categoryImage = (this.category) ? this.category.imageWide : cover;
        }, 300)
        this.$router.replace('/projects/' + this.category.url)
        this.projectsList = this.projects.filter((p) => {
          if(p.Categories.length > 0){
            if(p.Categories[0] && p.Categories[0].CategoryId === CategoryId){
              return true;
            }
            if(p.Categories[1] && p.Categories[1].CategoryId === CategoryId){
              return true
            }
          }
        });
        this.projectsListBackup = this.projectsList
      }else{
        this.projectsList = this.projects;
        this.projectsListBackup = this.projectsList
        this.category = null;
        this.categoryImage = cover;
        this.$router.replace('/projects')
      }
      this.loading = false;
    },
    selectFavoritedCategories()
    {
      this.selectedFeat = true;
      this.selectedFav = false;
      this.category = false;
      this.ods = null;
      this.categoryImage = coverFeatured;
      this.$router.replace('/projects/featured')
      var projectsFavorite = this.projects.filter(p => {

      })
      this.projectsList = projectsFavorite;
    },
    selectFavoritedProjects()
    {
      this.selectedFav = true;
      this.selectedFeat = false;
      this.category = false;
      this.ods = null;
      this.categoryImage = coverFeatured;
      this.$router.replace('/projects/favorites')
      var projectsFavorite = []
      if(this.user.favoritedProjects && this.user.favoritedProjects.length){
        this.projects.map(p => {
          var found = this.user.favoritedProjects.find(i => {
                return i == p.ProjectId;
          })
          if(found){
            projectsFavorite.push(p);
          }
        })
      }
      this.projectsList = projectsFavorite;
    },
    filterByODS(event)
    {
      var projects = [];
      if(event.length){
        this.projectsList.map(p => {
          if(p.ODS)
          {
            event.map(ods => {
              var found = p.ODS.find(i => {
                return i == ods;
              })
              if(found){
                projects.push(p);
              }
            })
          }
        })
      }else{
        projects = this.projects;
      }

      this.projectsList = projects;
    },
    getODS(slug){
      var odsList = Functions.getOdsList();
      var ods = odsList.filter((o) => {
        return o.slug == slug;
      })

      var ods = ods.map((o) => {
        return {
          ...o,
          image: this.arrODSImages[o.number - 1]
        }
      })
      return ods[0]
    },
    getDonationsValue(project){
      var value = 0.0;
      project.Donations.map((d) => {
        value += parseFloat(d.value);
      })
      return Functions.numberToReal(value)
    },
    openProject(slug){
      this.$router.push({path: '/project/' + slug});
    },
    openProjectInNewTab(slug){
      var routeData = this.$router.resolve({path: '/project/' + slug});
      window.open(routeData.href, '_blank');
    },
    searchProjectByCity(){
      if(this.searchCity != null){
        if(this.searchCity.length == 0){
          this.clearSearch()
        }else{
          if(this.searchCity.length > 2){
            var string = this.searchCity.toLowerCase();
            this.projectsList = this.projectsListBackup.filter((p) => {
              if(p.Info.city){
                var city = p.Info.city.toLowerCase();
                return city.search(string) !== -1
              }
            })
          }
        }
      }
    },
    clearSearch(){
      this.projectsList = this.projectsListBackup
      this.searchCity = null;
    },
    donate(project){
      this.selectedProject = project;
      this.ProjectId = project.ProjectId;
      this.$refs.userDataModal.show();
    },
    submitFormDonation(e)
    {
      e.preventDefault();
      this.loading = true;
      this.loadingMessage = "Aguarde, iniciando pagamento..."
      var donationValueText = parseFloat(this.donationValue.replace(".", "").replace(",", "."));
      this.integralDonationValue = (donationValueText > 0.0) ? donationValueText : this.donationValue;
      if(this.integralDonationValue){
        this.$refs.userDataModal.hide();
        this.$http.post(API.Invite.registerDonation, {
          ProjectId: this.ProjectId,
          donationValue: this.integralDonationValue,
          message: this.donationMessage,
        }).then((res) => {
          this.loading = false;
          var DonationId = res.body.DonationId;
          this.methodPagarme(DonationId);
        });
      }else{
        this.loading = false;
        this.donationModalMsg = 'Você deve definir um valor e uma mensagem para a doação!';
        this.donationModalMsgShow = true;
      }
    },
    methodPagarme(DonationId){
      var $this = this;
      // inicia a instância do checkout
      var checkout = new PagarMeCheckout.Checkout({
        encryption_key: 'ek_live_eMgIJ1T98Ru5U0K8hDHHkwRp8yLisM',
        // encryption_key: 'ek_test_BGBezpiqx7ZKxMAvh2d7azSUDrNZBo',
        success: function(data) {
          $this.loading = true;
          var params = {paymentMethod: data.payment_method, token: data.token};
          $this.$http.post(API.Invite.processPayment + DonationId, params).then((res) => {
            var donation = res.body.donation;
            var postback = JSON.parse(donation.postback);
            alert("Sucesso! Sua doação foi realizada.")
          }, (error) => {
            if(error.body.message){
              alert(error.body.message);
              $this.msg = error.body.message;
            }else{
              alert('Ocorreu um erro no processamento do seu pagamento. Tente novamente.');
            }
            $this.msgShow = true;
            $this.loading = false;
          });
        },
        error: function(err) {
          console.log("ERROR")
          console.log(err)
          alert("Erro ao processar a sua doação!");
        },
        close: function() {
          console.log('The modal has been closed.');
        }
      });

      // Obs.: é necessário passar os valores boolean como string
      checkout.open({
        amount: this.integralDonationValue.value * 100,
        buttonText: 'Pagar',
        buttonClass: 'botao-pagamento',
        customerData: 'true',
        createToken: 'false',
        paymentMethods: 'credit_card, boleto',
        uiColor: '#00AE39',
        postbackUrl: API.Invite.processNotification + DonationId,
        items: [{
          "id": DonationId,
          "title": "Doação para " + $this.selectedProject.Info.title,
          "unit_price": $this.integralDonationValue + '00',
          "quantity": 1,
          "tangible": "false"
        }]
      });
    },
    hideMsg(){
      this.msgShow = false;
      this.msg = "";
      this.donationModalMsg = "";
      this.donationModalMsgShow = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  #categories-list{
    font-family: RalewayRegular;
    h4{
      font-family: RalewayBold;
      padding: 10px;
      padding-left: 0px;
    }

    @media screen and (max-width: 767px ){
        .location-title, .location-form, .onu-title, .onu-form{
          display: none;
        }
    }

    ul{
      list-style: none;
      padding: 10px;
      padding-left: 0px;

      @media screen and (max-width: 767px ){
        display: flex;
        overflow-x: scroll;

        li{
          min-width: 120px;
          text-align: center;
          display: inline-table;
        }
      }

      li{
        padding: 3px;
        a{
          color: #777;
          text-decoration: none;
        }
        &.active{
          a{
            font-family: RalewayBold;
            color: #00AE39;
          }
        }
      }
    }

    form{

      button{
        color: #fff;
        background-color: #00AE39;
      }

    }
  }

  #projects-list{
    padding-bottom: 50px;

    .breadcrumb-list{
      font-family: RalewayBold;

      ul{
        margin-bottom: 20px;
        list-style: none;
        margin-left: 0px;
        padding: 0;

        li{
          display: inline-block;

          &.active{
            color: #00ae39;
            font-size: 20px;

            &::before{
              padding: 0 5px;
              color: #434343;
              content: ">";
              font-size: 20px;
            }
          }
        }
      }
    }

    .category-cover{
      background-color: #000;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 240px;

      img{
        position: absolute;
        width: 100%;
        height: 100%;
        opacity: 0.6;
      }

      .content{
        font-family: RalewayBold;
        width: 100%;
        position: absolute;
        top: 30%;
        padding: 20px;
        color: #fff;
      }
    }

    .tabs{
      margin-top: 20px;

      .filter{
        list-style: none;
        padding: 0;
        margin-top: 20px;

        li{
          display: inline;
          padding: 10px;
          margin-right: 20px;

          a{
            font-size: 18px;
            font-family: RalewayBold;
            color: #392f2f;
            text-decoration: none;
          }

          &.active{
            border-bottom: 3px solid #00AE39;
            a{
              color: #00AE39;
            }
          }
        }
      }
    }

    .projects{

      .item{
        background-color: #fff;
        padding: 15px;
        padding-bottom: 65px;
        margin-top: 20px;
        font-family: RalewayRegular;
        cursor: pointer;

        &:hover{
          box-shadow: 0px 1px 20px #888888;
        }

        .image{
          width: 100%;
          height: 155px;
          overflow: hidden;
          position: relative;

          img{
            width: 100%;
            height: 150px;
          }

          .one-click{
            z-index: 10;
            position: absolute;
            left: 0px;
            bottom: 5px;
            background-color: #fff;
            color: #00AE39;
          }
        }

        .content{
          button{
            display: block;
            margin: 0 auto;
            margin-bottom: 5px;
          }
          h5{
            font-family: RalewayBold;
            font-size: 18px;
            margin-top: 5px;
          }

          .tags{
            padding-top: 10px;
            padding-bottom: 10px;
            white-space: nowrap;

            a{
              margin-right: 5px;
              padding: 5px;
              border-radius: 5px;
              background-color: #00AE39;
              color: #fff;
              text-decoration: none;
              font-size: 12px;
              font-weight: bold;
              float: left;
              margin-top: 5px;
              display: block;
            }
          }

          .description{
            display: block;
            margin-bottom: 0px;
          }

          .donations{
            margin-top: 5px;
            margin-bottom: 5px;
            display: block;
          }

          span{
            b{
              color: #00AE39;
            }
          }

        }
      }

      &.not-found{
        margin-top: 50px;
        width: 100%;
        display: block;
        text-align: center;
      }

      .project-ods{
        width: 20px;
        height: 20px;
        float: left;
        display: inline-table;
        margin-right: 5px;

        img{
          width: 100%;
        }
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue